const TopNewsSkelton = () => {
  return (
    <div className="flex gap-x-[14px] skelton-all py-[12px]">
      <div className="w-[78px] h-[67px] flex-shrink-0" />
      <div className="w-full h-[64px]" />
    </div>
  );
};

export default TopNewsSkelton;
